export default "__VITE_ASSET__e8b3429d__"